export const STORAGE_KEYS = {
  id: 'id',
  username: 'username',
  role: 'role',
  roleId: 'role_id',
  token: 'token',
  scopes: 'scopes',
  lang: 'lang',
};

export const normalizeRoleName = (role) => {
  if (!role) return '';
  if (typeof role === 'string') return role;
  if (typeof role === 'number') return String(role);
  return role?.name || role?.role || role?.role_name || '';
};

export const parseScopes = (rawScopes) => {
  if (!rawScopes) return [];
  try {
    const parsed = JSON.parse(rawScopes);
    return Array.isArray(parsed) ? parsed : [];
  } catch (error) {
    console.error('Error al cargar scopes ' + error);
    return [];
  }
};

export const getStoredUser = () => {
  const token = localStorage.getItem(STORAGE_KEYS.token) || '';
  const scopes = parseScopes(localStorage.getItem(STORAGE_KEYS.scopes));
  return {
    id: localStorage.getItem(STORAGE_KEYS.id) || 0,
    username: localStorage.getItem(STORAGE_KEYS.username) || '',
    role: localStorage.getItem(STORAGE_KEYS.role) || '',
    token,
    scopes,
  };
};

export const storeUserSession = ({ id, username, role, token, scopes, roleId, lang }) => {
  const roleName = normalizeRoleName(role);
  localStorage.setItem(STORAGE_KEYS.username, username);
  localStorage.setItem(STORAGE_KEYS.id, id);
  localStorage.setItem(STORAGE_KEYS.role, roleName || '');
  if (roleId !== undefined && roleId !== null) {
    localStorage.setItem(STORAGE_KEYS.roleId, roleId);
  }
  localStorage.setItem(STORAGE_KEYS.token, token);
  localStorage.setItem(STORAGE_KEYS.scopes, JSON.stringify(scopes || []));
  if (lang) {
    localStorage.setItem(STORAGE_KEYS.lang, lang);
  }
  return roleName;
};

export const clearUserSession = () => {
  localStorage.clear();
};
